import React from 'react';

export const TickIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m9.45 17.85-5.6-5.6 1.075-1.075L9.45 15.7l9.6-9.6 1.075 1.075L9.45 17.85Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m6.225 18.825-1.05-1.05L10.95 12 5.175 6.225l1.05-1.05L12 10.95l5.775-5.775 1.05 1.05L13.05 12l5.775 5.775-1.05 1.05L12 13.05l-5.775 5.775Z"
      fill="currentColor"
    />
  </svg>
);

export const AddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.25 12.75H5v-1.5h6.25V5h1.5v6.25H19v1.5h-6.25V19h-1.5v-6.25Z" fill="currentColor" />
  </svg>
);

export const RemoveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 12.75v-1.5h14v1.5H5Z" fill="currentColor" />
  </svg>
);

export const ArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m12 4 1.05 1.075-6.175 6.175H20v1.5H6.875l6.175 6.175L12 20l-8-8 8-8Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m12 20-1.05-1.075 6.175-6.175H4v-1.5h13.125L10.95 5.075 12 4l8 8-8 8Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M14.625 6 15.7 7.075l-4.95 4.95 4.95 4.95-1.075 1.075L8.6 12.025 14.625 6Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M9.375 18 8.3 16.925l4.95-4.95-4.95-4.95L9.375 5.95l6.025 6.025L9.375 18Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M18 14.625 16.925 15.7l-4.95-4.95-4.95 4.95-1.075-1.075L11.975 8.6 18 14.625Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M6 9.375 7.075 8.3l4.95 4.95 4.95-4.95 1.075 1.075-6.025 6.025L6 9.375Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowDropDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 15-5-4.975h10L12 15Z" fill="currentColor" />
  </svg>
);

export const TickCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M10.525 16.55 17.6 9.475 16.45 8.35l-5.925 5.925-3-3L6.4 12.4l4.125 4.15ZM12 22a9.676 9.676 0 0 1-3.875-.788 10.144 10.144 0 0 1-3.188-2.15 10.142 10.142 0 0 1-2.15-3.187A9.676 9.676 0 0 1 2 12a9.74 9.74 0 0 1 .788-3.9 9.994 9.994 0 0 1 2.15-3.175 10.25 10.25 0 0 1 3.187-2.137A9.676 9.676 0 0 1 12 2a9.74 9.74 0 0 1 3.9.788 10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.676 9.676 0 0 1-.788 3.875 10.25 10.25 0 0 1-2.137 3.188 9.994 9.994 0 0 1-3.175 2.15A9.738 9.738 0 0 1 12 22Zm0-1.5c2.367 0 4.375-.83 6.025-2.488C19.675 16.354 20.5 14.35 20.5 12c0-2.367-.825-4.375-2.475-6.025C16.375 4.325 14.367 3.5 12 3.5c-2.35 0-4.354.825-6.013 2.475C4.33 7.625 3.5 9.633 3.5 12c0 2.35.83 4.354 2.487 6.012C7.646 19.671 9.65 20.5 12 20.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CancelCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M8.25 16.8 12 13.05l3.75 3.75 1.05-1.05L13.05 12l3.75-3.75-1.05-1.05L12 10.95 8.25 7.2 7.2 8.25 10.95 12 7.2 15.75l1.05 1.05ZM12 22a9.676 9.676 0 0 1-3.875-.788 10.144 10.144 0 0 1-3.188-2.15 10.142 10.142 0 0 1-2.15-3.187A9.676 9.676 0 0 1 2 12a9.74 9.74 0 0 1 .788-3.9 9.994 9.994 0 0 1 2.15-3.175 10.25 10.25 0 0 1 3.187-2.137A9.676 9.676 0 0 1 12 2a9.74 9.74 0 0 1 3.9.788 10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.676 9.676 0 0 1-.788 3.875 10.25 10.25 0 0 1-2.137 3.188 9.994 9.994 0 0 1-3.175 2.15A9.738 9.738 0 0 1 12 22Zm0-1.5c2.367 0 4.375-.83 6.025-2.488C19.675 16.354 20.5 14.35 20.5 12c0-2.367-.825-4.375-2.475-6.025C16.375 4.325 14.367 3.5 12 3.5c-2.35 0-4.354.825-6.013 2.475C4.33 7.625 3.5 9.633 3.5 12c0 2.35.83 4.354 2.487 6.012C7.646 19.671 9.65 20.5 12 20.5Z"
      fill="currentColor"
    />
  </svg>
);

export const AddCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M11.325 17h1.5v-4.15H17v-1.5h-4.175V7h-1.5v4.35H7v1.5h4.325V17Zm.682 5a9.68 9.68 0 0 1-3.888-.788 10.162 10.162 0 0 1-3.181-2.15 10.155 10.155 0 0 1-2.15-3.183A9.698 9.698 0 0 1 2 11.988c0-1.38.263-2.678.788-3.892a10.006 10.006 0 0 1 2.15-3.171c.908-.9 1.969-1.612 3.183-2.137A9.698 9.698 0 0 1 12.012 2c1.38 0 2.678.263 3.892.788a10.111 10.111 0 0 1 3.171 2.137c.9.9 1.613 1.958 2.137 3.175A9.721 9.721 0 0 1 22 11.993a9.68 9.68 0 0 1-.788 3.888 10.214 10.214 0 0 1-2.137 3.177c-.9.905-1.958 1.622-3.175 2.15a9.672 9.672 0 0 1-3.893.792Zm.005-1.5c2.359 0 4.363-.83 6.013-2.488 1.65-1.658 2.475-3.666 2.475-6.024 0-2.359-.823-4.363-2.47-6.013C16.383 4.325 14.373 3.5 12 3.5c-2.35 0-4.354.823-6.013 2.47C4.33 7.617 3.5 9.627 3.5 12c0 2.35.83 4.354 2.487 6.012 1.659 1.659 3.667 2.488 6.025 2.488Z"
      fill="currentColor"
    />
  </svg>
);

export const RemoveCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M7 12.675h10v-1.5H7v1.5ZM12 22a9.676 9.676 0 0 1-3.875-.788 10.144 10.144 0 0 1-3.188-2.15 10.142 10.142 0 0 1-2.15-3.187A9.676 9.676 0 0 1 2 12a9.74 9.74 0 0 1 .788-3.9 9.994 9.994 0 0 1 2.15-3.175 10.25 10.25 0 0 1 3.187-2.137A9.676 9.676 0 0 1 12 2a9.74 9.74 0 0 1 3.9.788 10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.676 9.676 0 0 1-.788 3.875 10.25 10.25 0 0 1-2.137 3.188 9.994 9.994 0 0 1-3.175 2.15A9.738 9.738 0 0 1 12 22Zm0-1.5c2.367 0 4.375-.83 6.025-2.488C19.675 16.354 20.5 14.35 20.5 12c0-2.367-.825-4.375-2.475-6.025C16.375 4.325 14.367 3.5 12 3.5c-2.35 0-4.354.825-6.013 2.475C4.33 7.625 3.5 9.633 3.5 12c0 2.35.83 4.354 2.487 6.012C7.646 19.671 9.65 20.5 12 20.5Z"
      fill="currentColor"
    />
  </svg>
);

export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M11.325 17h1.5v-6h-1.5v6ZM12 9.15c.233 0 .43-.077.588-.23a.762.762 0 0 0 .237-.57.836.836 0 0 0-.237-.606.786.786 0 0 0-.587-.244.787.787 0 0 0-.588.244.835.835 0 0 0-.238.606c0 .227.079.417.237.57a.81.81 0 0 0 .588.23ZM12.007 22a9.68 9.68 0 0 1-3.888-.788 10.162 10.162 0 0 1-3.181-2.15 10.155 10.155 0 0 1-2.15-3.183A9.698 9.698 0 0 1 2 11.988c0-1.38.263-2.678.788-3.892a10.006 10.006 0 0 1 2.15-3.171c.908-.9 1.969-1.612 3.183-2.137A9.698 9.698 0 0 1 12.012 2c1.38 0 2.678.263 3.892.788a10.111 10.111 0 0 1 3.171 2.137c.9.9 1.613 1.958 2.137 3.175A9.721 9.721 0 0 1 22 11.993a9.68 9.68 0 0 1-.788 3.888 10.214 10.214 0 0 1-2.137 3.177c-.9.905-1.958 1.622-3.175 2.15a9.672 9.672 0 0 1-3.893.792Zm.005-1.5c2.359 0 4.363-.83 6.013-2.488 1.65-1.658 2.475-3.666 2.475-6.024 0-2.359-.823-4.363-2.47-6.013C16.383 4.325 14.373 3.5 12 3.5c-2.35 0-4.354.823-6.013 2.47C4.33 7.617 3.5 9.627 3.5 12c0 2.35.83 4.354 2.487 6.012 1.659 1.659 3.667 2.488 6.025 2.488Z"
      fill="currentColor"
    />
  </svg>
);

export const CarouselLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m10.9 12 3.25-3.25-1.05-1.075L8.775 12l4.325 4.325 1.05-1.075L10.9 12ZM12 2a9.74 9.74 0 0 1 3.9.788 9.994 9.994 0 0 1 3.175 2.15c.9.908 1.613 1.97 2.137 3.187A9.676 9.676 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22a9.649 9.649 0 0 1-3.887-.788 10.292 10.292 0 0 1-3.175-2.137 9.994 9.994 0 0 1-2.15-3.175A9.738 9.738 0 0 1 2 12c0-1.367.263-2.658.788-3.875a10.143 10.143 0 0 1 2.15-3.188 10.183 10.183 0 0 1 3.175-2.15A9.649 9.649 0 0 1 12 2Zm0 1.5c-2.35 0-4.354.83-6.013 2.487C4.33 7.646 3.5 9.65 3.5 12c0 2.367.83 4.375 2.487 6.025C7.646 19.675 9.65 20.5 12 20.5c2.367 0 4.375-.825 6.025-2.475 1.65-1.65 2.475-3.658 2.475-6.025 0-2.35-.825-4.354-2.475-6.013C16.375 4.33 14.367 3.5 12 3.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CarouselRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m13.1 12-3.25 3.25 1.05 1.075L15.225 12 10.9 7.675 9.85 8.75 13.1 12ZM12 22a9.738 9.738 0 0 1-3.9-.788 9.994 9.994 0 0 1-3.175-2.15 10.25 10.25 0 0 1-2.137-3.187A9.676 9.676 0 0 1 2 12a9.74 9.74 0 0 1 .788-3.9 10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.68.263 3.887.788a10.292 10.292 0 0 1 3.175 2.137 9.994 9.994 0 0 1 2.15 3.175A9.738 9.738 0 0 1 22 12a9.676 9.676 0 0 1-.788 3.875 10.143 10.143 0 0 1-2.15 3.188 10.184 10.184 0 0 1-3.175 2.15A9.649 9.649 0 0 1 12 22Zm0-1.5c2.35 0 4.354-.83 6.012-2.488C19.671 16.354 20.5 14.35 20.5 12c0-2.367-.83-4.375-2.488-6.025C16.354 4.325 14.35 3.5 12 3.5c-2.367 0-4.375.825-6.025 2.475C4.325 7.625 3.5 9.633 3.5 12c0 2.35.825 4.354 2.475 6.012C7.625 19.671 9.633 20.5 12 20.5Z"
      fill="currentColor"
    />
  </svg>
);

export const UserIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M5.55 17.625c1.05-.733 2.092-1.296 3.125-1.688A9.302 9.302 0 0 1 12 15.35c1.183 0 2.296.196 3.338.588 1.041.391 2.087.954 3.137 1.687.733-.9 1.254-1.808 1.563-2.725A9.036 9.036 0 0 0 20.5 12c0-2.417-.813-4.438-2.438-6.063C16.438 4.313 14.418 3.5 12 3.5c-2.417 0-4.438.813-6.063 2.438C4.313 7.563 3.5 9.582 3.5 12a8.81 8.81 0 0 0 .475 2.9c.317.917.842 1.825 1.575 2.725Zm6.445-4.875c-.963 0-1.774-.33-2.432-.992-.659-.662-.988-1.474-.988-2.438 0-.963.33-1.774.992-2.433.662-.658 1.474-.987 2.438-.987.963 0 1.774.33 2.432.992.659.662.988 1.474.988 2.438 0 .963-.33 1.774-.992 2.432-.662.659-1.474.988-2.438.988Zm.017 9.25a9.705 9.705 0 0 1-3.887-.788 10.144 10.144 0 0 1-3.188-2.15 10.162 10.162 0 0 1-2.15-3.181A9.68 9.68 0 0 1 2 11.993c0-1.379.263-2.672.788-3.88a10.183 10.183 0 0 1 2.15-3.175 10.162 10.162 0 0 1 3.181-2.15A9.68 9.68 0 0 1 12.007 2c1.379 0 2.672.263 3.88.788a10.183 10.183 0 0 1 3.175 2.15 10.18 10.18 0 0 1 2.15 3.175c.526 1.21.788 2.5.788 3.875s-.262 2.67-.788 3.887a10.143 10.143 0 0 1-2.15 3.188 10.18 10.18 0 0 1-3.175 2.15 9.622 9.622 0 0 1-3.875.787ZM12 20.5a9.16 9.16 0 0 0 2.688-.4c.874-.267 1.737-.733 2.587-1.4a10.9 10.9 0 0 0-2.6-1.375A7.875 7.875 0 0 0 12 16.85c-.9 0-1.792.158-2.675.475a10.9 10.9 0 0 0-2.6 1.375c.85.667 1.713 1.133 2.588 1.4.874.267 1.77.4 2.687.4Zm0-9.25c.567 0 1.03-.18 1.387-.537.359-.359.538-.821.538-1.388s-.18-1.03-.538-1.387C13.03 7.579 12.567 7.4 12 7.4c-.567 0-1.03.18-1.387.537-.359.359-.538.821-.538 1.388s.18 1.03.538 1.388c.358.358.82.537 1.387.537Z"
      fill="currentColor"
    />
  </svg>
);

export const PersonIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 11.975c-1.1 0-2-.35-2.7-1.05-.7-.7-1.05-1.6-1.05-2.7s.35-2 1.05-2.7c.7-.7 1.6-1.05 2.7-1.05s2 .35 2.7 1.05c.7.7 1.05 1.6 1.05 2.7s-.35 2-1.05 2.7c-.7.7-1.6 1.05-2.7 1.05ZM4 20v-2.35c0-.633.158-1.175.475-1.625A3.05 3.05 0 0 1 5.7 15c1.117-.5 2.188-.875 3.212-1.125A12.987 12.987 0 0 1 12 13.5c1.033 0 2.058.13 3.075.387 1.017.259 2.083.631 3.198 1.118.522.235.94.577 1.255 1.024.315.447.472.988.472 1.621V20H4Zm1.5-1.5h13v-.85c0-.267-.08-.52-.238-.762a1.504 1.504 0 0 0-.587-.538c-1.067-.517-2.042-.87-2.925-1.063-.883-.191-1.8-.287-2.75-.287s-1.875.096-2.775.287c-.9.192-1.875.546-2.925 1.063a1.42 1.42 0 0 0-.575.537c-.15.242-.225.496-.225.763v.85Zm6.5-8.025c.65 0 1.188-.213 1.613-.638.425-.425.637-.962.637-1.612 0-.65-.213-1.188-.637-1.613-.425-.425-.963-.637-1.613-.637s-1.188.212-1.613.637c-.425.425-.637.963-.637 1.613s.213 1.187.637 1.612c.425.425.963.638 1.613.638Z"
      fill="currentColor"
    />
  </svg>
);

export const PeopleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M0.950195 20V17.65C0.950195 17.0666 1.1002 16.5375 1.4002 16.0625C1.7002 15.5875 2.11686 15.2333 2.6502 15C3.86686 14.4666 4.9627 14.0833 5.9377 13.85C6.9127 13.6166 7.91686 13.5 8.9502 13.5C9.98353 13.5 10.9835 13.6166 11.9502 13.85C12.9169 14.0833 14.0085 14.4666 15.2252 15C15.7585 15.2333 16.1794 15.5875 16.4877 16.0625C16.796 16.5375 16.9502 17.0666 16.9502 17.65V20H0.950195ZM18.4502 20V17.65C18.4502 16.6 18.1835 15.7375 17.6502 15.0625C17.1169 14.3875 16.4169 13.8416 15.5502 13.425C16.7002 13.5583 17.7835 13.7541 18.8002 14.0125C19.8169 14.2708 20.6419 14.5666 21.2752 14.9C21.8252 15.2166 22.2585 15.6083 22.5752 16.075C22.8919 16.5416 23.0502 17.0666 23.0502 17.65V20H18.4502ZM8.9502 11.975C7.8502 11.975 6.9502 11.625 6.2502 10.925C5.5502 10.225 5.2002 9.32498 5.2002 8.22498C5.2002 7.12498 5.5502 6.22498 6.2502 5.52498C6.9502 4.82498 7.8502 4.47498 8.9502 4.47498C10.0502 4.47498 10.9502 4.82498 11.6502 5.52498C12.3502 6.22498 12.7002 7.12498 12.7002 8.22498C12.7002 9.32498 12.3502 10.225 11.6502 10.925C10.9502 11.625 10.0502 11.975 8.9502 11.975ZM17.9502 8.22498C17.9502 9.32498 17.6002 10.225 16.9002 10.925C16.2002 11.625 15.3002 11.975 14.2002 11.975C14.0169 11.975 13.8127 11.9625 13.5877 11.9375C13.3627 11.9125 13.1585 11.8666 12.9752 11.8C13.3752 11.3833 13.6794 10.8708 13.8877 10.2625C14.096 9.65414 14.2002 8.97498 14.2002 8.22498C14.2002 7.47498 14.096 6.81248 13.8877 6.23748C13.6794 5.66248 13.3752 5.13331 12.9752 4.64998C13.1585 4.59998 13.3627 4.55831 13.5877 4.52498C13.8127 4.49164 14.0169 4.47498 14.2002 4.47498C15.3002 4.47498 16.2002 4.82498 16.9002 5.52498C17.6002 6.22498 17.9502 7.12498 17.9502 8.22498ZM2.4502 18.5H15.4502V17.65C15.4502 17.3833 15.371 17.125 15.2127 16.875C15.0544 16.625 14.8585 16.45 14.6252 16.35C13.4252 15.8166 12.4169 15.4583 11.6002 15.275C10.7835 15.0916 9.9002 15 8.9502 15C8.0002 15 7.1127 15.0916 6.2877 15.275C5.4627 15.4583 4.4502 15.8166 3.2502 16.35C3.01686 16.45 2.8252 16.625 2.6752 16.875C2.5252 17.125 2.4502 17.3833 2.4502 17.65V18.5ZM8.9502 10.475C9.6002 10.475 10.1377 10.2625 10.5627 9.83748C10.9877 9.41248 11.2002 8.87498 11.2002 8.22498C11.2002 7.57498 10.9877 7.03748 10.5627 6.61248C10.1377 6.18748 9.6002 5.97498 8.9502 5.97498C8.3002 5.97498 7.7627 6.18748 7.3377 6.61248C6.9127 7.03748 6.7002 7.57498 6.7002 8.22498C6.7002 8.87498 6.9127 9.41248 7.3377 9.83748C7.7627 10.2625 8.3002 10.475 8.9502 10.475Z"
      fill="currentColor"
    />
  </svg>
);

export const ShoppingCartIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M7.17 21.975c-.496 0-.92-.177-1.27-.53a1.747 1.747 0 0 1-.525-1.275c0-.497.177-.92.53-1.27.354-.35.78-.525 1.276-.525s.92.177 1.27.53c.35.354.524.779.524 1.275 0 .497-.176.92-.53 1.27-.353.35-.778.525-1.275.525Zm10 0c-.496 0-.92-.177-1.27-.53a1.747 1.747 0 0 1-.525-1.275c0-.497.177-.92.53-1.27.354-.35.78-.525 1.276-.525s.92.177 1.27.53c.35.354.524.779.524 1.275 0 .497-.176.92-.53 1.27-.354.35-.779.525-1.275.525ZM5.875 5.475l2.75 5.7h7.2l3.125-5.7H5.875Zm-.75-1.5h14.727c.383 0 .674.175.874.525.2.35.2.7 0 1.05l-3.376 6.075c-.183.317-.42.57-.714.762a1.719 1.719 0 0 1-.96.288H8.1l-1.4 2.6h12.275v1.5H6.925c-.7 0-1.204-.233-1.512-.7-.308-.467-.304-.992.012-1.575l1.6-2.95-3.8-8.05h-1.95V2H4.2l.925 1.975Z"
      fill="currentColor"
    />
  </svg>
);

export const ShoppingBagIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M5.5 22c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-13c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h2.75v-.25c0-1.05.363-1.938 1.088-2.663C10.063 2.362 10.95 2 12 2c1.05 0 1.938.362 2.662 1.087.725.725 1.088 1.613 1.088 2.663V6h2.75c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v13c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-13Zm0-1.5h13v-13h-2.75v2.25a.72.72 0 0 1-.217.534.732.732 0 0 1-.537.216.731.731 0 0 1-.746-.75V7.5h-4.5v2.25a.72.72 0 0 1-.217.534.732.732 0 0 1-.537.216.731.731 0 0 1-.746-.75V7.5H5.5v13ZM9.75 6h4.5v-.25c0-.633-.217-1.167-.65-1.6-.433-.433-.967-.65-1.6-.65-.633 0-1.167.217-1.6.65-.433.433-.65.967-.65 1.6V6Z"
      fill="currentColor"
    />
  </svg>
);

export const BurgerMenuIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 18v-1.5h18V18H3Zm0-5.25v-1.5h18v1.5H3ZM3 7.5V6h18v1.5H3Z" fill="currentColor" />
  </svg>
);

export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M19.9 20.975 13.325 14.4c-.5.433-1.083.77-1.749 1.012a6.186 6.186 0 0 1-2.126.363c-1.803 0-3.328-.625-4.577-1.875S3 11.142 3 9.375C3 7.608 3.625 6.1 4.875 4.85c1.25-1.25 2.763-1.875 4.537-1.875 1.775 0 3.284.625 4.525 1.875C15.18 6.1 15.8 7.61 15.8 9.379c0 .714-.117 1.404-.35 2.071a6.346 6.346 0 0 1-1.05 1.875l6.6 6.55-1.1 1.1Zm-10.475-6.7c1.354 0 2.505-.48 3.453-1.438S14.3 10.726 14.3 9.376s-.474-2.504-1.422-3.463c-.948-.958-2.099-1.437-3.453-1.437-1.368 0-2.53.48-3.489 1.437C4.98 6.871 4.5 8.025 4.5 9.375s.479 2.504 1.436 3.463c.958.958 2.121 1.437 3.489 1.437Z"
      fill="currentColor"
    />
  </svg>
);

export const CalendarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M4.5 22c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05V5c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h1.625V2H7.75v1.5h8.5V2h1.625v1.5H19.5c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v15.5c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-15Zm0-1.5h15V9.75h-15V20.5Zm0-12.25h15V5h-15v3.25ZM12 14a.968.968 0 0 1-.713-.287A.968.968 0 0 1 11 13c0-.283.096-.52.287-.713A.968.968 0 0 1 12 12c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.968.968 0 0 1 12 14Zm-4 0a.967.967 0 0 1-.713-.287A.968.968 0 0 1 7 13c0-.283.096-.52.287-.713A.967.967 0 0 1 8 12c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.967.967 0 0 1 8 14Zm8 0a.968.968 0 0 1-.713-.287A.968.968 0 0 1 15 13c0-.283.096-.52.287-.713A.968.968 0 0 1 16 12a.97.97 0 0 1 .712.287c.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 16 14Zm-4 4a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 17a.97.97 0 0 1 .287-.712A.968.968 0 0 1 12 16a.97.97 0 0 1 .713.288c.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0 1 12 18Zm-4 0a.967.967 0 0 1-.713-.288A.968.968 0 0 1 7 17a.97.97 0 0 1 .287-.712A.967.967 0 0 1 8 16a.97.97 0 0 1 .713.288c.191.191.287.429.287.712s-.096.52-.287.712A.967.967 0 0 1 8 18Zm8 0a.968.968 0 0 1-.713-.288A.968.968 0 0 1 15 17a.97.97 0 0 1 .287-.712A.968.968 0 0 1 16 16c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 16 18Z"
      fill="currentColor"
    />
  </svg>
);

export const LockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M5.5 22a1.45 1.45 0 0 1-1.06-.44A1.445 1.445 0 0 1 4 20.5V9.65c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h1.75v-2.4c0-1.314.463-2.434 1.39-3.36C9.567 1.462 10.688 1 12.003 1s2.434.463 3.36 1.39c.925.926 1.387 2.046 1.387 3.36v2.4h1.75c.413 0 .766.147 1.06.44.293.294.44.648.44 1.06V20.5c0 .413-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-13Zm0-1.5h13V9.65h-13V20.5Zm6.504-3.5c.53 0 .984-.184 1.359-.55a1.79 1.79 0 0 0 .562-1.325c0-.5-.189-.954-.567-1.363-.378-.408-.832-.612-1.362-.612-.53 0-.984.204-1.359.612-.375.409-.562.867-.562 1.375 0 .509.189.946.567 1.313.378.367.832.55 1.362.55ZM8.75 8.15h6.5v-2.4c0-.903-.316-1.67-.947-2.302-.631-.632-1.398-.948-2.3-.948a3.14 3.14 0 0 0-2.303.948 3.13 3.13 0 0 0-.95 2.302v2.4Z"
      fill="currentColor"
    />
  </svg>
);

export const EmailIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M3.5 20c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-13c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h17c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v13c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-17Zm8.5-7.55L3.5 6.875V18.5h17V6.875L12 12.45Zm0-1.5 8.4-5.45H3.625L12 10.95ZM3.5 6.875V5.5v13V6.875Z"
      fill="currentColor"
    />
  </svg>
);

export const AlternateEmailIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12a9.74 9.74 0 0 1 .788-3.9 10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2a9.74 9.74 0 0 1 3.9.788 10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12v1.325c0 .933-.33 1.72-.988 2.363-.658.641-1.462.962-2.412.962a3.49 3.49 0 0 1-1.7-.438 2.972 2.972 0 0 1-1.225-1.237 3.953 3.953 0 0 1-1.625 1.263 5.208 5.208 0 0 1-2.05.412c-1.3 0-2.404-.45-3.313-1.35-.908-.9-1.362-2-1.362-3.3 0-1.3.454-2.408 1.362-3.325C9.597 7.758 10.7 7.3 12 7.3c1.3 0 2.404.458 3.313 1.375.908.917 1.362 2.025 1.362 3.325v1.325c0 .517.188.95.563 1.3.375.35.829.525 1.362.525.517 0 .962-.175 1.337-.525.375-.35.563-.783.563-1.3V12c0-2.367-.825-4.375-2.475-6.025C16.375 4.325 14.367 3.5 12 3.5c-2.367 0-4.375.825-6.025 2.475C4.325 7.625 3.5 9.633 3.5 12c0 2.367.825 4.375 2.475 6.025C7.625 19.675 9.633 20.5 12 20.5h5.35V22H12Zm0-6.85c.883 0 1.633-.304 2.25-.912.617-.609.925-1.355.925-2.238 0-.9-.308-1.658-.925-2.275S12.883 8.8 12 8.8s-1.633.308-2.25.925S8.825 11.1 8.825 12c0 .883.308 1.63.925 2.238.617.608 1.367.912 2.25.912Z"
      fill="currentColor"
    />
  </svg>
);

export const EditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m19.85 7.35-3.2-3.2L17.7 3.1c.283-.283.637-.42 1.063-.412.424.008.779.154 1.062.437L20.9 4.2c.283.283.425.633.425 1.05 0 .417-.142.767-.425 1.05l-1.05 1.05ZM18.8 8.4 6.2 21H3v-3.2L15.6 5.2l3.2 3.2Z"
      fill="currentColor"
    />
  </svg>
);

export const ViewIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12.003 15.75c1.181 0 2.184-.414 3.01-1.24.825-.827 1.237-1.832 1.237-3.013 0-1.181-.414-2.184-1.24-3.01-.827-.825-1.832-1.237-3.013-1.237-1.181 0-2.184.413-3.01 1.24-.825.827-1.237 1.832-1.237 3.013 0 1.181.413 2.184 1.24 3.01.827.825 1.832 1.237 3.013 1.237Zm-.009-1.45c-.78 0-1.44-.273-1.982-.818a2.716 2.716 0 0 1-.812-1.988c0-.78.273-1.44.818-1.982a2.716 2.716 0 0 1 1.988-.812c.78 0 1.44.273 1.982.818.541.546.812 1.208.812 1.988s-.273 1.44-.818 1.982a2.716 2.716 0 0 1-1.988.812ZM12 19c-2.433 0-4.633-.692-6.6-2.075C3.433 15.542 1.967 13.733 1 11.5c.967-2.233 2.433-4.042 4.4-5.425C7.367 4.692 9.567 4 12 4s4.633.692 6.6 2.075c1.967 1.383 3.433 3.192 4.4 5.425-.967 2.233-2.433 4.042-4.4 5.425C16.633 18.308 14.433 19 12 19Z"
      fill="currentColor"
    />
  </svg>
);

export const CreditCardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M22 5.5v13c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-17c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-13c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h17c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05ZM3.5 8.225h17V5.5h-17v2.725Zm0 3.225v7.05h17v-7.05h-17Z"
      fill="currentColor"
    />
  </svg>
);

export const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 17a.8.8 0 0 0 .588-.237.797.797 0 0 0 .237-.588.8.8 0 0 0-.237-.588.797.797 0 0 0-.587-.237.8.8 0 0 0-.588.237.797.797 0 0 0-.238.588c0 .233.079.43.237.587A.797.797 0 0 0 12 17Zm-.675-3.825h1.5V6.85h-1.5v6.325ZM12.007 22a9.68 9.68 0 0 1-3.888-.788 10.162 10.162 0 0 1-3.181-2.15 10.155 10.155 0 0 1-2.15-3.183A9.698 9.698 0 0 1 2 11.988c0-1.38.263-2.678.788-3.892a10.006 10.006 0 0 1 2.15-3.171c.908-.9 1.969-1.612 3.183-2.137A9.698 9.698 0 0 1 12.012 2c1.38 0 2.678.263 3.892.788a10.111 10.111 0 0 1 3.171 2.137c.9.9 1.613 1.958 2.137 3.175A9.721 9.721 0 0 1 22 11.993a9.68 9.68 0 0 1-.788 3.888 10.214 10.214 0 0 1-2.137 3.177c-.9.905-1.958 1.622-3.175 2.15a9.672 9.672 0 0 1-3.893.792Zm.005-1.5c2.359 0 4.363-.83 6.013-2.488 1.65-1.658 2.475-3.666 2.475-6.024 0-2.359-.823-4.363-2.47-6.013C16.383 4.325 14.373 3.5 12 3.5c-2.35 0-4.354.823-6.013 2.47C4.33 7.617 3.5 9.627 3.5 12c0 2.35.83 4.354 2.487 6.012 1.659 1.659 3.667 2.488 6.025 2.488Z"
      fill="currentColor"
    />
  </svg>
);

export const ClockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M15.675 16.825 16.8 15.7l-3.975-4V6.675h-1.5V12.3l4.35 4.525ZM12 22a9.676 9.676 0 0 1-3.875-.788 10.144 10.144 0 0 1-3.188-2.15 10.142 10.142 0 0 1-2.15-3.187A9.676 9.676 0 0 1 2 12c0-1.367.263-2.658.788-3.875a10.143 10.143 0 0 1 2.15-3.188 10.143 10.143 0 0 1 3.187-2.15A9.676 9.676 0 0 1 12 2c1.367 0 2.658.263 3.875.788a10.142 10.142 0 0 1 3.188 2.15c.908.908 1.625 1.97 2.15 3.187A9.676 9.676 0 0 1 22 12a9.676 9.676 0 0 1-.788 3.875 10.143 10.143 0 0 1-2.15 3.188 10.143 10.143 0 0 1-3.187 2.15A9.676 9.676 0 0 1 12 22Zm0-1.5c2.333 0 4.333-.833 6-2.5 1.667-1.667 2.5-3.667 2.5-6s-.833-4.333-2.5-6c-1.667-1.667-3.667-2.5-6-2.5S7.667 4.333 6 6c-1.667 1.667-2.5 3.667-2.5 6s.833 4.333 2.5 6c1.667 1.667 3.667 2.5 6 2.5Z"
      fill="currentColor"
    />
  </svg>
);

export const BedsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M1 19V4.375h1.5v9.85h8.825V6.5h8.05c.997 0 1.85.355 2.56 1.065S23 9.128 23 10.125V19h-1.5v-3.275h-19V19H1Zm5.75-6.225c-.75 0-1.38-.254-1.888-.763-.508-.508-.762-1.137-.762-1.887s.254-1.38.763-1.887C5.37 7.729 6 7.475 6.75 7.475s1.38.254 1.887.763c.509.508.763 1.137.763 1.887s-.254 1.38-.763 1.887c-.508.509-1.137.763-1.887.763Zm6.075 1.45H21.5v-4.1c0-.584-.208-1.085-.624-1.5A2.046 2.046 0 0 0 19.375 8h-6.55v6.225Zm-6.075-2.95c.317 0 .588-.113.813-.338.224-.224.337-.495.337-.812 0-.317-.113-.588-.338-.813a1.108 1.108 0 0 0-.812-.337c-.317 0-.588.113-.813.338a1.108 1.108 0 0 0-.337.812c0 .317.113.588.338.813.224.224.495.337.812.337Z"
      fill="currentColor"
    />
  </svg>
);

export const TableIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M7.125 22v-9.2c-.867-.183-1.604-.62-2.213-1.313C4.304 10.796 4 9.968 4 9V2h1.5v7h1.625V2h1.5v7h1.625V2h1.5v7c0 .967-.304 1.796-.912 2.488-.609.691-1.346 1.129-2.213 1.312V22h-1.5ZM17.5 22v-8h-2.875V6.375c0-1.317.4-2.375 1.2-3.175.8-.8 1.858-1.2 3.175-1.2v20h-1.5Z"
      fill="currentColor"
    />
  </svg>
);

export const SpaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 22c-1.2-.133-2.396-.48-3.588-1.038A10.728 10.728 0 0 1 5.2 18.637c-.95-.991-1.72-2.216-2.313-3.675C2.296 13.504 2 11.808 2 9.876v-.951h.95c.883 0 1.825.17 2.825.512 1 .342 1.883.78 2.65 1.313.133-1.5.533-3.046 1.2-4.638.667-1.591 1.458-2.954 2.375-4.087.917 1.133 1.708 2.496 2.375 4.087.667 1.592 1.067 3.138 1.2 4.638.767-.5 1.65-.93 2.65-1.288s1.942-.537 2.825-.537H22v.95c0 1.933-.296 3.63-.887 5.087-.592 1.459-1.363 2.684-2.313 3.675-.95.992-2.02 1.767-3.213 2.325-1.191.559-2.387.905-3.587 1.038Zm.2-1.525c-.183-3.1-1.078-5.452-2.685-7.055-1.606-1.603-3.603-2.593-5.99-2.97.217 3.217 1.154 5.617 2.813 7.2 1.658 1.583 3.612 2.525 5.862 2.825Zm-.225-6.125c.233-.433.554-.9.963-1.4.408-.5.804-.917 1.187-1.25.083-1.133-.083-2.283-.5-3.45A27.116 27.116 0 0 0 12 4.625a27.116 27.116 0 0 0-1.625 3.625c-.417 1.167-.583 2.317-.5 3.45.383.333.77.75 1.162 1.25.392.5.705.967.938 1.4Zm1.725 5.7a13.31 13.31 0 0 0 2.338-1.125 8.32 8.32 0 0 0 2.1-1.825c.624-.75 1.15-1.67 1.574-2.763.425-1.091.68-2.387.763-3.887-1.767.283-3.325.912-4.675 1.887-1.35.975-2.342 2.18-2.975 3.613.2.633.375 1.27.525 1.912.15.642.267 1.371.35 2.188Z"
      fill="currentColor"
    />
  </svg>
);

export const TreatmentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M16.15 12.55c-.783-.7-1.53-1.383-2.237-2.05a23.339 23.339 0 0 1-1.861-1.949 10.89 10.89 0 0 1-1.275-1.836C10.459 6.123 10.3 5.55 10.3 5c0-.863.293-1.587.88-2.172.588-.585 1.313-.878 2.178-.878.495 0 .988.137 1.48.412.491.275.929.646 1.312 1.113.383-.467.82-.838 1.313-1.113.491-.275.984-.412 1.479-.412.864 0 1.59.293 2.177.878S22 4.138 22 5c0 .551-.159 1.123-.477 1.715a10.89 10.89 0 0 1-1.275 1.836 23.388 23.388 0 0 1-1.865 1.953c-.711.67-1.456 1.352-2.233 2.046Zm0-2.075c1.1-1 2.1-1.992 3-2.975.9-.983 1.35-1.817 1.35-2.5 0-.457-.145-.83-.434-1.118-.29-.288-.663-.432-1.122-.432-.28 0-.556.067-.831.2-.276.133-.555.383-.838.75L16.15 5.775 15.025 4.4c-.283-.367-.563-.617-.838-.75a1.89 1.89 0 0 0-.83-.2c-.46 0-.834.144-1.123.432-.29.288-.434.66-.434 1.118 0 .683.45 1.517 1.35 2.5.9.983 1.9 1.975 3 2.975Zm-2 11.975-7.775-2.225v1.425H1V11.8h7.725l6.375 2.4c.45.167.83.438 1.138.813.308.374.462.912.462 1.612h2.85c.7 0 1.283.25 1.75.75.467.5.7 1.175.7 2.025v.65l-7.85 2.4ZM2.5 20.15h2.35V13.3H2.5v6.85Zm11.55.75 6.4-1.95c-.1-.317-.225-.533-.375-.65a.83.83 0 0 0-.525-.175h-5.175c-.5 0-.963-.033-1.387-.1a8.91 8.91 0 0 1-1.213-.275l-2.025-.625.55-1.45 1.825.6c.417.133.813.225 1.188.275.374.05.97.075 1.787.075a1.6 1.6 0 0 0-.112-.587.726.726 0 0 0-.388-.413L8.475 13.3h-2.1v5.35l7.675 2.25Z"
      fill="currentColor"
    />
  </svg>
);

export const FacilityIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M3 21v-1.5h2.3V3h9.75v1.125h3.675V19.5H21V21h-3.775V5.625H15.05V21H3Zm8.275-8c.283 0 .52-.096.713-.287a.968.968 0 0 0 .287-.713.968.968 0 0 0-.287-.713.968.968 0 0 0-.713-.287.968.968 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.713.192.191.43.287.713.287ZM6.8 19.5h6.75v-15H6.8v15Z"
      fill="currentColor"
    />
  </svg>
);

export const PostIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M5.603 19.975a2.85 2.85 0 0 1-2.09-.86 2.841 2.841 0 0 1-.863-2.09H1V5.5c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h14.475v4.175H19.6L23 12.7v4.325h-1.775c0 .82-.287 1.516-.86 2.09a2.84 2.84 0 0 1-2.087.86 2.85 2.85 0 0 1-2.09-.86 2.841 2.841 0 0 1-.863-2.09H8.55a2.85 2.85 0 0 1-.86 2.088 2.837 2.837 0 0 1-2.087.862Zm-.003-1.5c.4 0 .742-.142 1.025-.425.283-.283.425-.625.425-1.025 0-.4-.142-.742-.425-1.025a1.397 1.397 0 0 0-1.025-.425c-.4 0-.742.142-1.025.425a1.397 1.397 0 0 0-.425 1.025c0 .4.142.742.425 1.025.283.283.625.425 1.025.425Zm-3.1-2.95h.55c.283-.45.642-.808 1.076-1.075.434-.267.917-.4 1.45-.4.533 0 1.02.137 1.462.412.441.276.804.63 1.087 1.063h7.35V5.5H2.5v10.025Zm15.775 2.95c.4 0 .742-.142 1.025-.425.283-.283.425-.625.425-1.025 0-.4-.142-.742-.425-1.025a1.397 1.397 0 0 0-1.025-.425c-.4 0-.742.142-1.025.425a1.397 1.397 0 0 0-.425 1.025c0 .4.142.742.425 1.025.283.283.625.425 1.025.425Zm-1.3-5.1h4.65l-2.775-3.7h-1.875v3.7Z"
      fill="currentColor"
    />
  </svg>
);

export const CollectIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21 11.025V19.5c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45H4.475c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-8.475A2.832 2.832 0 0 1 2.05 9.55 3.129 3.129 0 0 1 2.1 7.8l1.075-3.375c.134-.45.367-.8.7-1.05.334-.25.717-.375 1.15-.375H18.85c.467 0 .875.13 1.226.388.35.258.591.604.724 1.037L21.9 7.8c.184.583.196 1.167.038 1.75A2.908 2.908 0 0 1 21 11.025Zm-6.75-.775c.484 0 .892-.158 1.226-.475.333-.317.466-.7.4-1.15L15.25 4.5h-2.5v4.125c0 .433.141.813.425 1.137.283.325.641.488 1.075.488Zm-4.675 0c.467 0 .863-.158 1.188-.475.325-.317.488-.7.488-1.15V4.5h-2.5l-.626 4.125c-.066.433.05.813.35 1.137.3.325.667.488 1.1.488Zm-4.55 0c.4 0 .746-.137 1.038-.412.292-.275.462-.613.512-1.013l.65-4.325h-2.5l-1.15 3.65c-.166.517-.1.996.2 1.438.3.441.717.662 1.25.662Zm13.926 0c.533 0 .954-.217 1.262-.65.308-.433.38-.917.212-1.45l-1.15-3.65h-2.5l.65 4.325c.05.4.221.738.513 1.013.292.275.63.412 1.013.412ZM4.475 19.5H19.5v-7.775c.017.017-.037.025-.162.025h-.387a2.79 2.79 0 0 1-1.188-.262c-.375-.175-.746-.446-1.113-.813-.266.333-.6.596-1 .787a3.02 3.02 0 0 1-1.325.288c-.5 0-.929-.07-1.287-.213-.358-.141-.704-.379-1.037-.712-.25.3-.567.53-.95.688a3.38 3.38 0 0 1-1.3.237c-.517 0-.976-.092-1.376-.275-.4-.183-.741-.45-1.025-.8-.4.35-.791.617-1.175.8a2.646 2.646 0 0 1-1.15.275h-.337a.569.569 0 0 1-.213-.025V19.5Z"
      fill="currentColor"
    />
  </svg>
);

export const FitnessCentreIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m13.75 21.9-1.05-1.05 3.55-3.55L6.7 7.75 3.15 11.3 2.1 10.25 3.5 8.8 2.1 7.4l2.125-2.125-1.05-1.05 1.05-1.05L5.3 4.2l2.1-2.1 1.4 1.4 1.45-1.4 1.05 1.05L7.75 6.7l9.55 9.55 3.55-3.55 1.05 1.05-1.4 1.45 1.4 1.4-2.15 2.15 1.05 1.05-1.05 1.05-1.05-1.05-2.1 2.1-1.4-1.4-1.45 1.4Z"
      fill="currentColor"
    />
  </svg>
);

export const GiftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M3.5 17.075V19.5h17v-2.425h-17ZM3.5 6h3.125a2.1 2.1 0 0 1-.2-.563 2.847 2.847 0 0 1-.075-.612c0-.785.275-1.452.825-2.001A2.696 2.696 0 0 1 9.15 2c.512 0 .986.13 1.422.388a2.98 2.98 0 0 1 1.028.987l.412.65.413-.65a3.09 3.09 0 0 1 1.025-1c.417-.25.866-.375 1.347-.375.802 0 1.478.27 2.028.813.55.541.825 1.215.825 2.021 0 .177-.02.358-.063.541A5.549 5.549 0 0 1 17.4 6h3.1c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v12c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-17c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-12c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45Zm0 8.4h17V7.5h-6.225l2.5 3.475-1.2.9L12 6.925l-3.575 4.95-1.2-.9 2.5-3.475H3.5v6.9Zm5.675-8.25c.367 0 .68-.13.938-.388.258-.258.387-.57.387-.937 0-.367-.13-.68-.387-.938a1.277 1.277 0 0 0-.938-.387c-.367 0-.68.13-.938.388-.258.258-.387.57-.387.937 0 .367.13.68.388.938.258.258.57.387.937.387Zm5.625 0c.382 0 .703-.13.962-.388s.388-.57.388-.937c0-.367-.13-.68-.388-.938A1.307 1.307 0 0 0 14.8 3.5c-.35 0-.654.13-.913.388-.258.258-.387.57-.387.937 0 .367.13.68.387.938.259.258.563.387.913.387Z"
      fill="currentColor"
    />
  </svg>
);

export const TicketIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m9.4 16.05 2.6-2.025 2.6 2.025-1-3.2 2.45-2.05h-3L12 7.75l-1.05 3.05h-3l2.45 2.05-1 3.2ZM3.5 20c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 2 18.5v-3.3a.72.72 0 0 1 .5-.7c.517-.183.92-.512 1.212-.988A2.84 2.84 0 0 0 4.15 12c0-.517-.146-1.017-.438-1.5a2.268 2.268 0 0 0-1.212-1 .721.721 0 0 1-.5-.7V5.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 3.5 4h17c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v3.3a.72.72 0 0 1-.5.7c-.517.183-.92.517-1.212 1a2.865 2.865 0 0 0-.438 1.5c0 .533.146 1.037.438 1.512.291.476.695.805 1.212.988a.721.721 0 0 1 .5.7v3.3c0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 20.5 20h-17Zm0-1.5h17v-2.725a5.34 5.34 0 0 1-1.55-1.625c-.4-.65-.6-1.367-.6-2.15 0-.783.2-1.5.6-2.15a5.34 5.34 0 0 1 1.55-1.625V5.5h-17v2.725c.65.433 1.17.975 1.563 1.625.391.65.587 1.367.587 2.15 0 .783-.196 1.5-.588 2.15A5.098 5.098 0 0 1 3.5 15.775V18.5Z"
      fill="currentColor"
    />
  </svg>
);

export const AmendIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2333 5.40008L11.1 3.26674L11.8 2.56674C11.9889 2.37785 12.225 2.28619 12.5083 2.29174C12.7917 2.2973 13.0278 2.39452 13.2167 2.58341L13.9333 3.30008C14.1222 3.48896 14.2167 3.7223 14.2167 4.00008C14.2167 4.27785 14.1222 4.51119 13.9333 4.70008L13.2333 5.40008ZM12.5333 6.10008L4.13333 14.5001H2V12.3667L10.4 3.96674L12.5333 6.10008Z"
      fill={props?.color ?? '#173946'}
    />
  </svg>
);
